import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_ESUS,
    useChartsData
} from '../../../Common/Filters/useChartsData';

export const MappingChartsDataContext = createContext();

const MappingChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_ESUS.REGISTERS_MAPPING,
            url: 'governanceroom/esus/registers/mapping'
        },
        {
            year: filters.ano.value,
            month: filters.competencia.map((competencia) => competencia.value),
            location: filters.unidade.value,
            city: filters.cidade?.governance_room_geo_city_id,
        }
    );

    const chartData = data
        ? {
              registersHoseHoldByHealthUnit:
                  data?.registersHoseHoldByHealthUnit ?? [],
              registersHoseHoldByTeam: data?.registersHoseHoldByTeam ?? [],
              registersHouseHoldByCoordinates:
                  data?.registersHouseHoldByCoordinates ?? []
          }
        : {
              registersHoseHoldByHealthUnit: [],
              registersHoseHoldByTeam: [],
              registersHouseHoldByCoordinates: []
          };

    return (
        <MappingChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </MappingChartsDataContext.Provider>
    );
};

export default MappingChartsDataProvider;
